import React from 'react';
import { Link } from 'gatsby';
import donationIcon from '../../images/givepage/donation.png';
import mailIcon from '../../images/givepage/mail.png';
import giftIcon from '../../images/givepage/gift.png';

const GivingOptionsSection = () => {
  const givingOptions = [
    {
      icon: donationIcon,
      title: 'Online Donation',
      description:
        'Support Lineage Journey with a quick and secure online gift. Together, we can make an eternal impact.',
      buttonText: 'Give Now',
      buttonAction: () => {
        window.scrollTo({ top: 0, behavior: 'smooth' });
      },
    },
    {
      icon: mailIcon,
      title: 'Gifts By Mail',
      description:
        'Prefer to give by mail? Please complete the following form and send your check to the following address: Lineage Journey, PO Box 405, Grass Valley, CA 95949',
      buttonText: 'Give By Mail',
      buttonAction: () => {
        window.open('/pdfs/lineage-donation-form.pdf', '_blank', 'noopener,noreferrer');
      },
    },
    {
      icon: giftIcon,
      title: 'Other Gifts',
      description: 'Explore giving through vehicles, property, valuables, estates, or living trusts.',
      buttonText: 'Find Out More',
      buttonAction: () => {
        window.location.href = '/other-gifts';
      },
    },
  ];

  return (
    <div className="giving-options-section">
      <p className="financial-standards-text">
        Every gift is put to maximum use with the highest{' '}
        <Link to="/policies/?tab=financial-standards" className="financial-standards-link">
          financial standards
        </Link>{' '}
        of integrity.
      </p>
      <div className="giving-options-container">
        {givingOptions.map((option, index) => (
          <div key={index} className="giving-option-card">
            <div className="option-icon">
              <img src={option.icon} alt={option.title} />
            </div>
            <div className="option-content">
              <h3 className="option-title">{option.title}</h3>
              <p className="option-description">{option.description}</p>
              <button className="option-button" onClick={option.buttonAction}>
                {option.buttonText}
              </button>
            </div>
          </div>
        ))}
      </div>
    </div>
  );
};

export default GivingOptionsSection;
